import { render, staticRenderFns } from "./form-index.vue?vue&type=template&id=5fb6c9c8"
import script from "./form-index.vue?vue&type=script&lang=js"
export * from "./form-index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports